<div class="card p-3">
  <div class="row">
    <div class="col-12 text-primary font-weight-bold mb-1 h6">
      {{ "DATA_STUDIO.DATA_PARAMETERS.TITLE" | translate }}
    </div>
    <div class="col-12 text-primary mb-4">
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div class="data-assets-container">
      <div class="col-12 text-primary font-weight-bold mb-2">
        {{ "DATA_STUDIO.DATA_PARAMETERS.DATA_ASSET" | translate }}
      </div>
      <!--Date Range -->
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-between">
          <span class="text-grey">{{
            "DATA_STUDIO.DATA_PARAMETERS.DATE_RANGE" | translate
          }}</span>
          @if (wrongDate) {
            <i
              class="far fa-info-circle text-danger"
              [matTooltip]="'DATA_STUDIO.DATA_PARAMETERS.CORRECT_DATE' | translate">
            </i>
          }
        </div>
        <div class="">
          <input
            type="text"
            class="form-control date-range-picker"
            name="date-data-studio"
            #drp="bsDaterangepicker"
            bsDaterangepicker
            [bsConfig]="bsConfig | async"
            [(ngModel)]="bsRangeValue"
            [maxDate]="maxDate"
            [minDate]="minDate"
            (bsValueChange)="changeDateRange($event)"
            [class.border-danger]="wrongDate"
            placement="bottom left"/>
        </div>
      </div>
      <!--Select Park -->
      @if (selectedAggregation === 'park') {
        <div class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_PARK" | translate }}</span>
          </div>
          @if (dataParks) {
            <lib-select
              id="data-park-select-park"
              [options]="dataParksNames"
              [label]="parkSelected?.fe_name"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [notBold]="true"
              [fullWidth]="true"
              [itemClasses]="'font-size-normal-small'"
              [doNotTranslate]="true"
              [container]="''"
              (selectedChanged)="selectPark($event)">
            </lib-select>
          }
        </div>
      }
    </div>
    @if (signalGroupArray.length > 0) {
      <div
        class="d-flex flex-column available-signals-container">
        <div class="text-primary font-weight-bold mb-2">
          {{ "DATA_STUDIO.DATA_PARAMETERS.AVAILABLE_SIGNALS" | translate }}
        </div>
        <div class="col-12 d-flex justify-content-between border rounded w-100 p-2 mb-3 text-primary">
          <mat-checkbox
            [checked]="selectAllSignalsFlag"
            (change)="selectAllSignals()">
            <b>{{ "DATA_STUDIO.SIGNALS.ALL_SIGNALS" | translate }}</b>
          </mat-checkbox>
          <span>
            <small>{{ totalSignalsSelected }} {{ "COMMON.OF" | translate }}
              {{ totalSignals }}
            </small>
          </span>
        </div>
        @for (signalGroup of signalGroupArray; track $index) {
          <div
            class="border rounded w-100 p-2 mb-3 text-primary">
            <div class="d-flex justify-content-between">
              <mat-checkbox
                [(ngModel)]="signalGroup.signalGroupName.checked"
                (change)="selectAllSignalsByGroup(signalGroup.signalGroupName.name)">
                <b>{{ signalGroup.signalGroupName.name | translate | titlecase }}</b>
              </mat-checkbox>
              @if (signalGroup.signalGroupName.name === 'park production' ||
                signalGroup.signalGroupName.name === 'DATA_STUDIO.SIGNALS.GROUPS.PARK_PRODUCTION') {
                <span
                  >
                  <small>
                    {{ parkProductionSignalGroupSelected }}
                    {{ "COMMON.OF" | translate }} {{ signalGroup.signals.length }}
                  </small>
                </span>
              }
              @if (signalGroup.signalGroupName.name === 'market price' ||
                signalGroup.signalGroupName.name === 'CHECK_REVENUES.OVERVIEW.REVENUE_CHART.LABELS.MARKET_PRICE') {
                <span
                  >
                  <small>
                    {{ marketPriceSignalGroupSelected }}
                    {{ "COMMON.OF" | translate }} {{ signalGroup.signals.length }}
                  </small>
                </span>
              }
            </div>
            <div>
              <hr class="my-1" />
            </div>
            <div class="row">
              @for (signals of signalGroup.signals; track $index; let i = $index) {
                <div
                  class="col-4 pr-2">
                  <mat-checkbox
                    [(ngModel)]="signals.checked"
                    [value]="signals.value"
                    (change)="checkSelectedSignals()">
                    <span [appCustomTooltip]="tooltipTemplate">{{ signals.name | translate | titlecase }} ({{ signals.unit }})</span>
                  </mat-checkbox>
                  <ng-template #tooltipTemplate>
                    <div>
                      <b>{{ signals.name | translate | titlecase }}</b><br />
                      {{ signals.value | titlecase }}
                    </div>
                  </ng-template>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
